import { jsxs as k, Fragment as M, jsx as x } from "react/jsx-runtime";
import { useState as m } from "react";
import { useAuth as $ } from "../../../context/auth/index.js";
import { useSchool as C } from "../../../context/school/index.js";
import { AzureUploadArgs as E } from "./AzureUploadArgs.js";
import { Input as R, Button as T } from "@mui/material";
import { AzureBlobs as I } from "./azureblobs.js";
import j from "@mui/icons-material/FileUpload";
const H = ({ type: b, parameters: g, onProgress: n, onStatus: s }) => {
  const { Get: d } = $(), { baseUrl: F } = C(), [u, U] = m(null), [r, h] = m(null);
  return /* @__PURE__ */ k(M, { children: [
    /* @__PURE__ */ x(
      R,
      {
        type: "file",
        inputProps: { accept: "image/*" },
        onChange: async (c) => {
          let f = c.target;
          if (!f.files)
            return;
          let p = f.files[0];
          h(p);
          let v = { ...g, fileName: p.name, size: String(p.size) }, w = await d(
            {
              url: F + "/" + E.getSasEndpoint(b, v),
              data: null,
              config: null
            }
          );
          w && U(w), n && n(null);
        },
        sx: {
          display: "block",
          flex: 1,
          marginTop: "10px",
          padding: "8px",
          border: "0",
          backgroundColor: "var(--mui-palette-primary-main)",
          color: "var(--mui-palette-primary-contrastText)",
          borderRadius: "var(--mui-shape-borderRadius)",
          "&:hover": {
            boxShadow: "var(--mui-shadows-4)"
          },
          "&::before": {
            border: "0 !important"
          },
          '& input[type="file"]': {
            cursor: "pointer"
          },
          '& input[type="file"]::file-selector-button': {
            border: "0",
            backgroundColor: "var(--mui-palette-primary-main)",
            color: "var(--mui-palette-primary-contrastText)"
          },
          '& input[type="file"]::file-upload-text': {
            color: "var(--mui-palette-primary-contrastText)"
          }
        }
      }
    ),
    /* @__PURE__ */ x(
      T,
      {
        variant: "contained",
        onClick: async () => {
          try {
            const c = new I(u), f = (p) => {
              n && n(p);
            };
            await c.uploadFileAsync(r, f);
          } catch (c) {
            s && s({ type: "error", message: `${r == null ? void 0 : r.name} failed to upload: ${c.message}` });
            return;
          }
          s && s({ type: "success", message: `${r == null ? void 0 : r.name} successfully uploaded` });
        },
        disabled: !u,
        startIcon: /* @__PURE__ */ x(j, {}),
        children: "Upload"
      }
    )
  ] });
}, J = () => {
  const { Get: b, Post: g } = $(), { baseUrl: n } = C(), [s, d] = m([]), [F, u] = m(!1), [U, r] = m(""), h = (a, e) => {
    d([...s, { file: a, type: e }]);
  }, z = (a, e) => {
    d([...s, ...a.map((l) => ({ file: l, type: e }))]);
  }, A = (a) => {
    const e = s.filter((l) => !(l.file.name === a.name && l.file.size === a.size));
    d(e);
  }, c = () => {
    d([]);
  }, f = async (a, e) => {
    u(!0), r("");
    for (const l of s)
      try {
        const t = await p(l, a);
        if (t) {
          const o = await new I(t).uploadFileAsync(l.file);
          if (!o)
            await g({
              url: `${n}/lms/api/files/upload/success`,
              data: { fileId: t.fileId },
              config: { asResponse: !0 }
            });
          else {
            const y = `${l.file.name} failed to upload: ${o}`;
            r(y), e == null || e({
              type: "error",
              message: y
            });
          }
        } else {
          const i = `Could not generate SAS token for ${l.file.name}`;
          r(i), e == null || e({
            type: "error",
            message: i
          });
        }
      } catch (t) {
        const i = (t == null ? void 0 : t.message) || "Failed to upload file. Please try again.";
        r(i), e == null || e({
          type: "error",
          message: i
        });
      }
    u(!1);
  }, p = async (a, e) => {
    const { file: l, type: t } = a;
    let i = { ...e, fileName: l.name, size: String(l.size) }, o = await b(
      {
        url: n + "/" + E.getSasEndpoint(t, i),
        data: null,
        config: null
      }
    );
    return o || null;
  };
  return { files: s, addFile: h, removeFile: A, uploadAll: f, addFiles: z, clearFiles: c, isUploading: F, uploadUrl: async (a, e, l, t, i) => {
    r("");
    try {
      const o = await g({
        url: `${n}/lms/api/files/upload/url`,
        data: {
          url: a,
          name: e,
          linkId: l,
          fileType: t,
          ownerId: i
        },
        config: null
      });
      return (o == null ? void 0 : o.success) ?? !1;
    } catch (o) {
      const y = (o == null ? void 0 : o.message) || "Failed to upload URL. Please try again.";
      throw r(y), o;
    }
  }, uploadError: U, clearUploadError: () => r("") };
};
export {
  H as AzureUpload,
  J as useAzureUpload
};
//# sourceMappingURL=AzureUpload.js.map
